import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { motion } from 'framer-motion';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import type { Suggestion } from '../../store/types';
import ChangesPanel from '../changes';
import { ACTIVITY_PANEL_MOBILE_MAX_WIDTH, ACTIVITY_PANEL_WIDTH } from '../layout';
import HistoryList from './history-list';
import { nextTabIndex } from './tab-nav';
const SIDEBAR_TABS = ['changes', 'history', 'releases'] as const;
type SidebarTab = (typeof SIDEBAR_TABS)[number];
type RightSidebarProps = {
  tab: SidebarTab;
  onTabChange: (tab: SidebarTab) => void;
  onNavigateToSuggestion: (suggestion: Suggestion) => void;
  pendingCount: number;
  onSelectVersion?: () => void;
};
const RightSidebar = t0 => {
  const $ = _c(69);
  const {
    tab,
    onTabChange,
    onNavigateToSuggestion,
    pendingCount,
    onSelectVersion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.history.tabs"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const baseId = useId();
  let t2;
  if ($[1] !== baseId) {
    t2 = value => `${baseId}-tab-${value}`;
    $[1] = baseId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const tabId = t2;
  const panelId = `${baseId}-panel`;
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp3);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = {
      changes: t3,
      history: t4,
      releases: t5
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const labels = t6;
  let T0;
  let activeTab;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t7;
  let t8;
  let t9;
  if ($[13] !== labels || $[14] !== onTabChange || $[15] !== panelId || $[16] !== pendingCount || $[17] !== t || $[18] !== tab || $[19] !== tabId) {
    const tabs = [...(pendingCount > 0 ? ["changes" as SidebarTab] : []), "history", "releases"];
    activeTab = tabs.includes(tab) ? tab : "history";
    const handleKeyDown = e => {
      const next = nextTabIndex(e.key, tabs.indexOf(activeTab), tabs.length);
      if (next === null) {
        return;
      }
      e.preventDefault();
      onTabChange(tabs[next]);
      e.currentTarget.querySelectorAll("[role=\"tab\"]")[next]?.focus();
    };
    T0 = motion.aside;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = {
        width: 0
      };
      t15 = {
        width: ACTIVITY_PANEL_WIDTH
      };
      t16 = {
        width: 0
      };
      $[34] = t14;
      $[35] = t15;
      $[36] = t16;
    } else {
      t14 = $[34];
      t15 = $[35];
      t16 = $[36];
    }
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = {
        duration: 0.2,
        ease: [0.4, 0, 0.2, 1]
      };
      t18 = cx("relative shrink-0 overflow-hidden max-md:absolute max-md:inset-y-0 max-md:right-0 max-md:z-20", ACTIVITY_PANEL_MOBILE_MAX_WIDTH);
      t12 = {
        width: ACTIVITY_PANEL_WIDTH
      };
      $[37] = t12;
      $[38] = t17;
      $[39] = t18;
    } else {
      t12 = $[37];
      t17 = $[38];
      t18 = $[39];
    }
    t13 = "absolute right-0 top-0 bottom-0 flex flex-col border-l border-tertiary bg-primary max-md:w-full!";
    t7 = "tablist";
    if ($[40] !== t) {
      t8 = t(_temp4);
      $[40] = t;
      $[41] = t8;
    } else {
      t8 = $[41];
    }
    t9 = handleKeyDown;
    t10 = "mt-3 shrink-0 flex items-stretch gap-4 px-4 border-b border-tertiary";
    t11 = tabs.map(value_0 => <TabButton key={value_0} id={tabId(value_0)} panelId={panelId} label={labels[value_0]} active={activeTab === value_0} count={value_0 === "changes" ? pendingCount : undefined} onSelect={() => onTabChange(value_0)} />);
    $[13] = labels;
    $[14] = onTabChange;
    $[15] = panelId;
    $[16] = pendingCount;
    $[17] = t;
    $[18] = tab;
    $[19] = tabId;
    $[20] = T0;
    $[21] = activeTab;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    T0 = $[20];
    activeTab = $[21];
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t14 = $[26];
    t15 = $[27];
    t16 = $[28];
    t17 = $[29];
    t18 = $[30];
    t7 = $[31];
    t8 = $[32];
    t9 = $[33];
  }
  let t19;
  if ($[42] !== t10 || $[43] !== t11 || $[44] !== t7 || $[45] !== t8 || $[46] !== t9) {
    t19 = <div role={t7} aria-label={t8} onKeyDown={t9} className={t10}>{t11}</div>;
    $[42] = t10;
    $[43] = t11;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  const t20 = tabId(activeTab);
  let t21;
  if ($[48] !== activeTab || $[49] !== onNavigateToSuggestion || $[50] !== onSelectVersion) {
    t21 = activeTab === "changes" ? <ChangesPanel onNavigate={onNavigateToSuggestion} /> : <div className="h-full overflow-y-auto"><HistoryList tab={activeTab} onSelectVersion={onSelectVersion} /></div>;
    $[48] = activeTab;
    $[49] = onNavigateToSuggestion;
    $[50] = onSelectVersion;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== panelId || $[53] !== t20 || $[54] !== t21) {
    t22 = <div role="tabpanel" id={panelId} aria-labelledby={t20} className="flex-1 min-h-0">{t21}</div>;
    $[52] = panelId;
    $[53] = t20;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t12 || $[57] !== t13 || $[58] !== t19 || $[59] !== t22) {
    t23 = <div style={t12} className={t13}>{t19}{t22}</div>;
    $[56] = t12;
    $[57] = t13;
    $[58] = t19;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== T0 || $[62] !== t14 || $[63] !== t15 || $[64] !== t16 || $[65] !== t17 || $[66] !== t18 || $[67] !== t23) {
    t24 = <T0 initial={t14} animate={t15} exit={t16} transition={t17} className={t18}>{t23}</T0>;
    $[61] = T0;
    $[62] = t14;
    $[63] = t15;
    $[64] = t16;
    $[65] = t17;
    $[66] = t18;
    $[67] = t23;
    $[68] = t24;
  } else {
    t24 = $[68];
  }
  return t24;
};
type TabButtonProps = {
  id: string;
  panelId: string;
  label: string;
  active: boolean;
  count?: number;
  onSelect: () => void;
};
const TabButton = t0 => {
  const $ = _c(18);
  const {
    id,
    panelId,
    label,
    active,
    count,
    onSelect
  } = t0;
  const showCount = count !== undefined && count > 0;
  const t1 = active ? 0 : -1;
  const t2 = showCount ? `${label} (${count})` : undefined;
  const t3 = active ? "text-primary" : "text-tertiary hover:text-secondary";
  let t4;
  if ($[0] !== t3) {
    t4 = cx("relative flex items-center gap-1.5 text-label-3 py-2.5 px-0.5 cursor-pointer transition-colors", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== count || $[3] !== showCount) {
    t5 = showCount && <span aria-hidden={true} className="min-w-[16px] h-4 px-1 rounded-full bg-accent/10 text-accent text-snippet-3 flex items-center justify-center">{count}</span>;
    $[2] = count;
    $[3] = showCount;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== active) {
    t6 = active && <span className="absolute -bottom-px left-0 right-0 h-0.5 rounded-full bg-current" />;
    $[5] = active;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== active || $[8] !== id || $[9] !== label || $[10] !== onSelect || $[11] !== panelId || $[12] !== t1 || $[13] !== t2 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <button type="button" role="tab" id={id} aria-selected={active} aria-controls={panelId} tabIndex={t1} aria-label={t2} onClick={onSelect} className={t4}>{label}{t5}{t6}</button>;
    $[7] = active;
    $[8] = id;
    $[9] = label;
    $[10] = onSelect;
    $[11] = panelId;
    $[12] = t1;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export type { SidebarTab };
export { SIDEBAR_TABS };
export default RightSidebar;
function _temp($) {
  return $.changes;
}
function _temp2($_0) {
  return $_0.history;
}
function _temp3($_1) {
  return $_1.releases;
}
function _temp4($_2) {
  return $_2.ariaLabel;
}